import React from 'react'

export default function Article() {
  return (
    <div>
      权限管理
    </div>
  )
}
